import React from "react";

const HemoglobinOutlined = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2926_9897"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2926_9897)">
        <path
          d="M11.9983 21.5001C9.85708 21.5001 8.07208 20.7645 6.64325 19.2933C5.21442 17.8221 4.5 15.9911 4.5 13.8001C4.5 12.2487 5.12083 10.5484 6.3625 8.69905C7.60417 6.84972 9.48333 4.83472 12 2.65405C14.5167 4.83472 16.3958 6.84972 17.6375 8.69905C18.8792 10.5484 19.5 12.2487 19.5 13.8001C19.5 15.9911 18.785 17.8221 17.355 19.2933C15.925 20.7645 14.1394 21.5001 11.9983 21.5001ZM12 20.0001C13.7333 20.0001 15.1667 19.4126 16.3 18.2376C17.4333 17.0626 18 15.5834 18 13.8001C18 12.5834 17.4958 11.2084 16.4875 9.67505C15.4792 8.14172 13.9833 6.46672 12 4.65005C10.0167 6.46672 8.52083 8.14172 7.5125 9.67505C6.50417 11.2084 6 12.5834 6 13.8001C6 15.5834 6.56667 17.0626 7.7 18.2376C8.83333 19.4126 10.2667 20.0001 12 20.0001ZM9.25 17.7501H14.75V16.2501H9.25V17.7501ZM11.25 14.7501H12.75V12.7501H14.75V11.2501H12.75V9.25005H11.25V11.2501H9.25V12.7501H11.25V14.7501Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default HemoglobinOutlined;
